import(/* webpackMode: "eager" */ "/vercel/path0/app/o-nama/page.tsx");
